<template>
  <div class="slider-content">
    <p>{{ label }}</p>
    <el-slider
      :value="value"
      :min="min"
      :max="max"
      :show-input-controls="false"
      @input="
        val => {
          $emit('input', val);
        }
      "
      show-input
    >
    </el-slider>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: ""
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 30
    }
  }
};
</script>

<style lang="less" scoped>
.slider-content {
  display: flex;
  align-items: center;
  > p {
    min-width: 72px;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
  }
  /deep/ .el-slider {
    flex: 1;
    .el-slider__input {
      width: 56px;
      .el-input__inner {
        border-radius: 2px;
        border: 1px solid #eeeeee;
      }
    }
    .el-slider__runway.show-input {
      margin-right: 68px;
      margin-left: 16px;
    }
    .el-slider__bar {
      background-color: #2154f4;
    }
    .el-slider__button {
      border: 2px solid #6086d9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SpSlider.vue